// Permission constants
export const PERMISSIONS = {
  // Document permissions
  DOCUMENTS: {
    UPLOAD: 'upload_document',
    DELETE: 'delete_document',
    DOWNLOAD: 'download_document',
    UPDATE: 'update_document',
    UNLOCK: 'unlock_document',
    REPROCESS: 'reprocess_document'  // Add this line
  },
  
  // Project permissions
  CREATE_PROJECT: 'create_project',
  EDIT_PROJECT: 'edit_project',
  DELETE_PROJECT: 'delete_project',
  VIEW_PROJECT: 'view_project',
  
  // User management permissions
  MANAGE_USERS: 'manage_users',
  VIEW_USERS: 'view_users',
  EDIT_USER_ROLES: 'edit_user_roles',
  CREATE_USER: 'create_user',
  DELETE_USER: 'delete_user',
  
  // Project team permissions
  MANAGE_TEAM: 'manage_team',
  VIEW_TEAM: 'view_team',
  
  // Settings permissions
  MANAGE_SETTINGS: 'manage_settings',
  VIEW_SETTINGS: 'view_settings',

  // Project management permission
  VIEW_PROJECT_MANAGEMENT: 'view_project_management',

  // Employee management permission
  MANAGE_EMPLOYEES: 'manage_employees',

  // Metrics permission
  VIEW_METRICS: 'view_metrics',

  // Beheer van standaard stoffenpakketten (Analyse-tab)
  MANAGE_STOFFENPAKKETTEN: 'manage_stoffenpakketten'
};

// Role-based permissions
export const ROLE_PERMISSIONS = {
  admin: [
    PERMISSIONS.CREATE_PROJECT,
    PERMISSIONS.EDIT_PROJECT,
    PERMISSIONS.DELETE_PROJECT,
    PERMISSIONS.VIEW_PROJECT,
    PERMISSIONS.DOCUMENTS.UPLOAD,
    PERMISSIONS.DOCUMENTS.DELETE,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.DOCUMENTS.UPDATE,
    PERMISSIONS.DOCUMENTS.UNLOCK,
    PERMISSIONS.DOCUMENTS.REPROCESS,  // Add this line
    PERMISSIONS.MANAGE_USERS,
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.EDIT_USER_ROLES,
    PERMISSIONS.CREATE_USER,
    PERMISSIONS.DELETE_USER,
    PERMISSIONS.MANAGE_TEAM,
    PERMISSIONS.VIEW_TEAM,
    PERMISSIONS.MANAGE_SETTINGS,
    PERMISSIONS.VIEW_SETTINGS,
    PERMISSIONS.VIEW_PROJECT_MANAGEMENT,
    PERMISSIONS.MANAGE_EMPLOYEES,
    PERMISSIONS.VIEW_METRICS,
    PERMISSIONS.MANAGE_STOFFENPAKKETTEN
  ],
  project_manager: [
    PERMISSIONS.CREATE_PROJECT,
    PERMISSIONS.EDIT_PROJECT,
    PERMISSIONS.VIEW_PROJECT,
    PERMISSIONS.DOCUMENTS.UPLOAD,
    PERMISSIONS.DOCUMENTS.DELETE,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.DOCUMENTS.UPDATE,
    PERMISSIONS.DOCUMENTS.UNLOCK,
    PERMISSIONS.DOCUMENTS.REPROCESS,  // Add this line
    PERMISSIONS.MANAGE_TEAM,
    PERMISSIONS.VIEW_TEAM,
    PERMISSIONS.VIEW_SETTINGS,
    PERMISSIONS.VIEW_PROJECT_MANAGEMENT,
    PERMISSIONS.MANAGE_EMPLOYEES,
    PERMISSIONS.VIEW_METRICS,
    PERMISSIONS.MANAGE_STOFFENPAKKETTEN
  ],
  user: [
    PERMISSIONS.VIEW_PROJECT,
    PERMISSIONS.DOCUMENTS.DOWNLOAD,
    PERMISSIONS.DOCUMENTS.REPROCESS, // Add this line
    PERMISSIONS.DOCUMENTS.UPLOAD, // Toegevoegd zodat users kunnen uploaden
    PERMISSIONS.VIEW_DOCUMENT,
    PERMISSIONS.VIEW_TEAM
  ]
};
